export default "__VITE_ASSET__CC7K9O6N__"